module.exports = __webpack_public_path__ + "static/media/power-on-dot.b13a9814.svg";